import { Injectable } from '@angular/core';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { Observable } from 'rxjs';
import { BydModel } from '@sixense/byd-core-service';
import { DsGroupFront } from '../models/ds-group-front';
import { Data } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DsProjectGroupsFrontService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get project user groups list.
   *
   * @param  projectId Project ID
   * @returns Observable type `<BydModel<DsGroup>>`
   */
  public getProjectIdGroups(projectId: number): Observable<BydModel<DsGroupFront>> {
    this.path = `/projects/${projectId}/groups`;
    return this.getModels<DsGroupFront>();
  }

  /**
   * Create DsGroup instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsGroup` instance.
   */
  public createNewInstance(jsonObject: Data): DsGroupFront {
    return new DsGroupFront(jsonObject);
  }
}
